import { createFileRoute } from "@tanstack/react-router";
import BuildingQuerySandbox from "lib/components/debug/BuildingQuerySandbox";
import withAuthentication from "../../components/withAuthentication";

export const Route = createFileRoute("/debug/building-query")({
  component: withAuthentication(BuildingQuerySandbox, { superAdmin: true }),
});
